package dev.lingvo.shared.screenshots.text

import dev.lingvo.shared.TextDirection
import dev.lingvo.shared.quoteStyleFor
import dev.lingvo.shared.textDirection
import kotlin.math.max

/** Derived display state keeps original captions intact for hashes and review. */
data class NormalisedText(
    val text: String, val script: Script, val lineHeight: Double, val letterSpacingEm: Double,
    val direction: TextDirection,
)

/** Applies locale typography before measurement so drawn strings match fitted strings. */
fun normalise(req: FitRequest): NormalisedText {
    val script = Scripts.scriptFor(req.locale, req.text)
    val row = Scripts.rows.getValue(script)
    var text = req.text.trim().replace(Regex("[ \\t]+"), " ")
    if (req.uppercase && script in setOf(Script.LATIN, Script.VIETNAMESE, Script.CYRILLIC)) {
        val language = req.locale.trim().replace('_', '-').substringBefore('-').lowercase()
        text = if (language == "tr" || language == "az") {
            text.replace('i', '\u0130').replace('\u0131', 'I').uppercase()
        } else text.uppercase()
    }
    if (req.quoted && text.isNotBlank()) {
        val quote = quoteStyleFor(req.locale)
        text = quote.open + text + quote.close
    }
    return NormalisedText(text, script, max(req.lineHeight, row.minLineHeight),
        if (row.letterSpacingAllowed) req.letterSpacingEm else 0.0, textDirection(req.locale))
}
